import { ProgressSpinner } from "primereact/progressspinner";

export default function ModuleProgressLoading() {
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center bg-black-alpha-20 z-1">
        <ProgressSpinner style={{ transform: "scale(0.5)" }} />
      </div>
    </>
  );
}
